var map = {
	"./PayMethod-Cash.png": "bc25",
	"./PayMethod-LinePay.png": "e75f",
	"./PayMethod-iPassMoney.png": "a4b4",
	"./back-arrow.svg": "9e57",
	"./back.svg": "ccfe",
	"./bg.png": "d68e",
	"./cancel-clock.svg": "c114",
	"./cancel.svg": "f687",
	"./cart-white.svg": "005d",
	"./cart.svg": "6f5d",
	"./cartdark.svg": "a0f3",
	"./clipboard-list-outline.svg": "f75f",
	"./clock-time-nine-outline.svg": "a48a",
	"./clock.svg": "e0f8",
	"./edit.svg": "6582",
	"./finish-clock.svg": "1be6",
	"./fork.png": "e9fe",
	"./fullscreen.png": "0ad7",
	"./hide.png": "e6d7",
	"./king.svg": "f506",
	"./list.svg": "e7e9",
	"./load-img1.png": "10f2",
	"./load-img2.png": "6896",
	"./load-img3.png": "d083",
	"./logoIcon.png": "6277",
	"./logout.png": "bc8c",
	"./maintenance.webp": "f507",
	"./male.svg": "c04b",
	"./maledark.svg": "62a8",
	"./map-marker.svg": "6e32",
	"./maximize.png": "bc6f",
	"./new.svg": "9cca",
	"./notice.png": "818f",
	"./oops.svg": "8105",
	"./order_pending.svg": "a606",
	"./partner.svg": "bf2e",
	"./pen.svg": "c4cc",
	"./phone.svg": "001e",
	"./plus.svg": "8a37",
	"./plus2.svg": "dba9",
	"./qrcode.svg": "2a97",
	"./reduce.svg": "9d4c",
	"./scroll-down.svg": "a2ad",
	"./search.svg": "51f2",
	"./spicy.png": "9c0d",
	"./switch.svg": "3533",
	"./trashcan.svg": "36dd",
	"./vegetarian.png": "183b",
	"./view.png": "b9d6",
	"./whatsEatCoupon.png": "b4ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";